import React, { useState,useRef,useEffect } from 'react';
import { Button, Card, Tabs, notification, Modal } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import './reporting.css';
import ButtonGroup from '../../../components/common/Button/ButtonGroup';
import { deleteEnergyData, getEnergyData, updateEnergyData } from '../../../redux/slices/energyslice';
import EnergyContent from '../../../components/reportingtab/EnergyContent';
import WasteContent from '../../../components/reportingtab/WasteContent';
import Packaging from '../../../components/reportingtab/Packaging';
import { NOTIFICATION_MESSAGES,tabListNoTitle,reportingNestedTabs,BUTTON_TEXT,CONFIRMATION_MESSAGES } from '../../../constants/Constants';
import Cdp from './Cdp';

const { TabPane } = Tabs;

const CdpReporting = () => {
  const dispatch = useDispatch();
  const cdpRef = useRef(null);
  const [activeTabKey, setActiveTabKey] = useState('sustainabilityReporting');
  const [activeNestedTabKey, setActiveNestedTabKey] = useState('energy');

  useEffect(() => {
    dispatch(getEnergyData());
  }, [dispatch]);

  const handleNext = () => {
    if (activeTabKey === 'cdpDetails') {
      setActiveTabKey('reporting');
    } else if (activeTabKey === 'reporting') {
      const currentIndex = reportingNestedTabs.findIndex(tab => tab.key === activeNestedTabKey);
      if (currentIndex < reportingNestedTabs.length - 1) {
        const nextTabKey = reportingNestedTabs[currentIndex + 1].key;
        setActiveNestedTabKey(nextTabKey);
      } else {
        notification.info({
          message: NOTIFICATION_MESSAGES.endOfTabs.message,
          description: NOTIFICATION_MESSAGES.endOfTabs.description,
        });
      }
    }
  };
  
  const handleReset = async () => {
    try {
    if (activeTabKey === 'cdpDetails' && cdpRef.current) {
        cdpRef.current.resetFields(); 
        notification.success({
          message: NOTIFICATION_MESSAGES.resetSuccessful.message,
          description: NOTIFICATION_MESSAGES.resetSuccessful.description,
        });
      } else if (activeTabKey === 'reporting') {
        await dispatch(deleteEnergyData()); 
        notification.success({
          message: NOTIFICATION_MESSAGES.resetSuccessful.message,
        description: NOTIFICATION_MESSAGES.resetSuccessful.description,
        });
        dispatch(getEnergyData());
      }
    } catch (err) {
      notification.error({
        message: NOTIFICATION_MESSAGES.resetFailed.message,
        description: NOTIFICATION_MESSAGES.resetFailed.description(err),
      });
    }
  };

const { confirm } = Modal;

const handleSave = async () => {
  
    try {
      if (activeTabKey === 'cdpDetails' && cdpRef.current) {
        cdpRef.current.saveData();
      } else if (activeTabKey === 'reporting') {
        await dispatch(updateEnergyData());
        notification.success({
          message: NOTIFICATION_MESSAGES.saveSuccessful.message,
        description: NOTIFICATION_MESSAGES.saveSuccessful.description,
        });
      }
    } catch (err) {
      notification.error({
        message: NOTIFICATION_MESSAGES.saveFailed.message,
        description: NOTIFICATION_MESSAGES.saveFailed.description(err),
      });
    }
  
};
const handleTabChange = async (newActiveTabKey) => {
  if (activeTabKey === 'cdpDetails' && cdpRef.current && cdpRef.current.hasChanges) {
    const isConfirmed = window.confirm(CONFIRMATION_MESSAGES.TABCHANGE);
    if (isConfirmed) {
      const saveSuccess = await cdpRef.current.saveData();
      if (saveSuccess) {
        setActiveTabKey(newActiveTabKey);
      }
    }
  } else {
    setActiveTabKey(newActiveTabKey);
  }
};

  const nestedTabContent = {
    energy: <EnergyContent  />,
    waste: <WasteContent />,
    packaging: <Packaging />,
  };

  const contentListNoTitle = {
    sustainabilityReporting: <p>Pre-survey</p>,
    cdpDetails: <Cdp ref={cdpRef}/>,
    
  };

  const buttonConfigs = [
    { text: BUTTON_TEXT.RESET, onClick: handleReset, style: { borderRadius: '25px' }},
    { text: BUTTON_TEXT.SAVE, onClick: handleSave, style: { borderRadius: '25px' },'data-testid': 'save-button'  },
    { text: BUTTON_TEXT.NEXT, onClick: handleNext, style: { borderRadius: '25px' }, disabled: (activeTabKey === 'reporting' && activeNestedTabKey === 'packaging') },
  ];

  return (
    <div className="reporting">
      <div className="headerContainer">
        <Button style={{backgroundColor:"#2C5778", color: "white"}} className="headerButton" type="primary" icon={<DownloadOutlined/>}>
          
          {BUTTON_TEXT.PDF_DOWNLOAD}
        </Button>
      </div>
      <div className="contentContainer">
        <Card
          className="customCard"
          tabList={tabListNoTitle}
          activeTabKey={activeTabKey}
          onTabChange={handleTabChange}
          tabProps={{ size: 'middle' }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </div>
      <div className="footerContainer">
        <ButtonGroup buttons={buttonConfigs} />
      </div>
    </div>
  );
};

export default CdpReporting;

